import DocumentTypeCatalog from '@/graphql/DocumentTypeCatalog.gql'

import { createProvider } from '../../vue-apollo'

const apollo = createProvider()

export default {
  async getDocumentTypeCatalogs ({ commit, dispatch }) {
    try {
      const result = await apollo.defaultClient.query({
        query: DocumentTypeCatalog,
        variables: {}
      })
      return result.data.FinancialCatalog.documentTypes
    } catch (error) {
      return { error: true, message: error.graphQLErrors[0].message }
    }
  }
}
